import {COUNTRY_SIZE_LIST_GET , COUNTRY_SIZE_LIST_SUCCESS,COUNTRY_SIZE_LIST_FAILURE} from './actions';

const initialState = {
    order: {},
    request:{},
}

export function CountrySizeListReducer(state = initialState, action) {
    
    if(action.type === COUNTRY_SIZE_LIST_GET) {
        return state;
    }
    if(action.type === COUNTRY_SIZE_LIST_SUCCESS) {
        return {
            ...state,
            order: {
                isLoaded: true,
                data: action.payload.res,
                message: 'Success'
            },
            request:action.payload.request
            
        }
    }
    if(action.type === COUNTRY_SIZE_LIST_FAILURE) {
        return {
            ...state,
            order: {
                data: [],
                message: action.payload.message
            },
            request:action.payload.request
        }
    }
    
    return state;
    
}



